import { SxProps } from '@cast/design-system';

import { RangePicker } from 'components/date';

import {
  NODE_STORAGE_FILTER_PRESETS,
  NODE_STORAGE_QUERY_PARAM_KEYS,
  useNodeStorageTimeRangeSelection,
} from './_hooks/useNodeStorageTimeRangeSelection';

type StorageRangePickerProps = {
  sx?: SxProps;
};

export const StorageRangePicker = ({ sx }: StorageRangePickerProps) => {
  const { initialState } = useNodeStorageTimeRangeSelection();

  return (
    <RangePicker
      sx={sx}
      allowTimeInput={true}
      queryParamKeys={NODE_STORAGE_QUERY_PARAM_KEYS}
      initialPreset={initialState.preset}
      initialTimezone={initialState.timeZone}
      filterPresets={NODE_STORAGE_FILTER_PRESETS}
      triggerInputProps={{
        size: 'small',
        sx: { minWidth: 230 },
      }}
    />
  );
};
